import {IStockModel, IStocks, StockProtocol} from '@/modules/stocks/IStockModel';
import StockService from '@/modules/stocks/StockService';
import {BaseStockModel} from '@/core/standard/BaseStockModel';
import BarStockServices from "@/modules/stock/BarStockServices";
import {GenericMethod} from '@/core/Types/IRepository';
import TPVServices from '@/modules/auth/TPVServices';


const stock = {
  uuid: '',
  name: '',
  location: '',
  description: '',
  warehouse_uuid: '',
  extras: {},
};

class StockModel extends BaseStockModel<IStockModel, StockProtocol> {
  public modelName = 'Stock';
  public request = 'FormData';
  public uniqueField = 'uuid';

  constructor() {
    super(stock, StockService);
  }

  public async getStockProductsFile(protocol: StockProtocol) {
    return await BarStockServices.downloadStockProductsFile({
      method: 'GET',
      query: protocol,
      headers: {Accept: '*/*'},
      responseType: 'blob',
    });
  }

}

export default StockModel as new() => IStocks;
